import { render, staticRenderFns } from "./WeighedByBatchG.vue?vue&type=template&id=96e605e2"
import script from "./WeighedByBatchG.vue?vue&type=script&lang=js"
export * from "./WeighedByBatchG.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports